export default __webpack_public_path__ + "static/media/order-in-dark.815a4465.svg";